import React from 'react';
import LazyLoadModule from '../../helpers/LazyLoadModule';

export default ({ title, tip, tabs, icon, selected }) => {
  const renderTab = (tab, i) => {
    var className = i === selected ? 'headerTab selected' : 'headerTab';

    return (
      <div key={i} className={className} onClick={() => tab.cb()}>{tab.name}</div>
    );
  }

  return (
    <div className="header">
      <div className="headerTitle">
        <LazyLoadModule resolve={() => import(`react-ionicons/lib/${icon}`)} className="headerIcon" fontSize="22px" />
        {title}
      </div>
      <div className="headerTip">{tip}</div>
      <div className="headerTabs">
        {tabs.map(renderTab)}
      </div>
    </div>
  )
}
